/* eslint indent: 0 */

import moment from 'moment';
import { leftPad } from 'zoomforth_zfutils/string_utils.js';

/**
  Datetime and duration formatting lib

  Mostly extending moment() with common operations.
*/

// Note that the browser returns the "difference" in mins from UTC, while moment()
// expects the minute "offset". Its very confusing. 
// Suffice to save we need to do multiply by `-1` for this to work
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset
const TIMEZONE_OFFSET_MINS = -(new Date().getTimezoneOffset());


  /*
    format a `moment()` object datetime consistent with the way we do things,
    optionally modified slightly by passed option flags
  */
const defaultDatetimeFormat = function(momentTs, { includeTime=false }={}) {

    const formattedTimestampStr = momentTs.calendar(null, {
      sameDay: '[Today] [at] h:mm a',
      lastDay: '[Yesterday] [at] h:mm a',
      lastWeek: 'l' + (includeTime ? ' [at] h:mm a': ''),
      sameElse: 'l' + (includeTime ? ' [at] h:mm a': '')
    });

    return formattedTimestampStr;
};


const reportingDatetimeFormat = (momentTs)=> {
  return momentTs.format('YYYY/MM/DD HH:mm:ss Z');
};


const defaultDateFormat = (momentTs)=> {
    return momentTs.format('MM/DD/YYYY');
};

  /**
    format a `moment.duration()` object in a standard way
  */
const defaultDurationFormat = function(duration) {
    const secs = Math.round(duration.as('seconds')) % 60;

    return (
      Math.floor(duration.as('minutes')) + 
      ':' + 
      (secs < 10 ? ('0' + secs) : ('' + secs))
    );
};

const defaultDurationFormatHourMinuteSecond = function(duration) {
  const hours = Math.floor(duration.asHours());

  if (hours <= 99 ) {
    return `${leftPad(hours, '0', 2)}:${leftPad(duration.minutes(), '0', 2)}:${leftPad(duration.seconds(), '0', 2)}`;
  } else {
    return '100+ Hours';
  }
};


const toLocalOffset = (momentTs)=>
  momentTs.utcOffset(TIMEZONE_OFFSET_MINS);


/**
  Return a moment() object which is always the nearest ten minute floor to
  the given moment() object.

  e.g., 2017-01-08-11:32:03.033Z --> 2017-01-08-11:30:00.000Z
        2017-01-08-11:39:53.103Z --> 2017-01-08-11:30:00.000Z
*/
const momentToTenMinuteFloorMoment = (timestamp)=> {
  var ROUNDING = 10 * 60 * 1000; // milliseconds
  return moment(Math.floor((+timestamp) / ROUNDING) * ROUNDING);
};

export {
  defaultDatetimeFormat,
  defaultDateFormat,
  defaultDurationFormat,
  defaultDurationFormatHourMinuteSecond,
  reportingDatetimeFormat,
  toLocalOffset,
  momentToTenMinuteFloorMoment 
};

export default {
  defaultDatetimeFormat,
  defaultDateFormat,
  defaultDurationFormat,
  reportingDatetimeFormat,
  toLocalOffset,
  momentToTenMinuteFloorMoment 
};
